// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_jd-0";
export var buttonContainer = "_jd-3";
export var cancelButton = "_jd-4";
export var headerSection = "_jd-6";
export var headerTitle = "_jd-9";
export var messageSideLeft = "_jd-1";
export var messageSideRight = "_jd-2";
export var orderNumberContainer = "_jd-7";
export var orderNumberLabel = "_jd-8";
export var submitButton = "_jd-5";